import React from 'react';
import OriginationsBoard from '../components/OriginationsBoard/OriginationsBoard';
import '../styles/originationsBoard.css';

const ComersOriginationsBoardPage = () => (
  <div className="page-content originations-board-page rg-shell-content">
    <OriginationsBoard />
  </div>
);

export default ComersOriginationsBoardPage;
